import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const P = styled.p`
  line-height: 175%;
  font-size: 1.1rem;
  margin: 1.25rem 0;
  text-align: ${props => props.centered ? 'center' : 'left'};
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class Paragraph extends Component {
  render() {
    const { str, inserts, children, ...props } = this.props

    return (
      <P {...props}>
        {!!str &&
          <Text str={str} inserts={inserts} />
        }
        {!str && children}
      </P>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Paragraph.js